/* BAF Saat — mobil menü: "Markalar" paneli ve harf kaydırıcı. */
(() => {
  const panel = () => document.querySelector('[data-bs-markalar]');

  const ac = () => {
    const p = panel();
    if (!p) return false;
    p.hidden = false;
    requestAnimationFrame(() => p.classList.add('is-acik'));
    p.querySelector('[data-bs-markalar-kapat]')?.focus({ preventScroll: true });
    return true;
  };
  const kapat = () => {
    const p = panel();
    if (!p) return;
    p.classList.remove('is-acik');
    const bitir = () => { p.hidden = true; };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) bitir();
    else p.addEventListener('transitionend', bitir, { once: true });
  };

  /* Ana listedeki "Markalar" öğesi (menü başlığı veya /pages/markalar bağlantısı) → bizim paneli aç */
  document.addEventListener(
    'click',
    (e) => {
      const oge = e.target.closest('.menu-drawer__menu-item--mainlist');
      if (!oge || !oge.closest('.header-drawer')) return;
      const ad = oge.textContent.trim().toLocaleLowerCase('tr-TR');
      const href = oge.getAttribute('href') || '';
      if (ad !== 'markalar' && !href.includes('/pages/markalar')) return;
      if (ac()) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-bs-markalar-kapat]')) kapat();
  });

  /* Harf kaydırıcı: dokun ve sürükle → harfe atla, balon + hafif titreşim */
  let sonHarf = '';
  const harfeGit = (x, y) => {
    const el = document.elementFromPoint(x, y);
    const harf = el?.closest('[data-bs-harf-kaydirici] [data-harf]')?.dataset.harf;
    if (!harf || harf === sonHarf) return;
    sonHarf = harf;
    const p = panel();
    const hedef = p?.querySelector(`.bs-markalar__harf[data-harf="${CSS.escape(harf)}"]`);
    const liste = p?.querySelector('[data-bs-markalar-liste]');
    if (hedef && liste) liste.scrollTop = hedef.offsetTop - liste.offsetTop;
    const balon = p?.querySelector('[data-bs-harf-balon]');
    if (balon) {
      balon.textContent = harf;
      balon.style.top = `${y}px`;
      balon.classList.add('is-gorunur');
    }
    if (navigator.vibrate) navigator.vibrate(4);
  };
  const birak = () => {
    sonHarf = '';
    panel()?.querySelector('[data-bs-harf-balon]')?.classList.remove('is-gorunur');
  };
  document.addEventListener('pointerdown', (e) => {
    const k = e.target.closest('[data-bs-harf-kaydirici]');
    if (!k) return;
    e.preventDefault();
    k.setPointerCapture(e.pointerId);
    harfeGit(e.clientX, e.clientY);
    const hareket = (ev) => harfeGit(ev.clientX, ev.clientY);
    k.addEventListener('pointermove', hareket);
    k.addEventListener('pointerup', () => { k.removeEventListener('pointermove', hareket); birak(); }, { once: true });
    k.addEventListener('pointercancel', () => { k.removeEventListener('pointermove', hareket); birak(); }, { once: true });
  });

  /* Çekmece kapanınca paneli de kapat */
  document.addEventListener('toggle', (e) => {
    if (e.target.id === 'Details-menu-drawer-container' && !e.target.open) {
      const p = panel();
      if (p) { p.classList.remove('is-acik'); p.hidden = true; }
    }
  }, true);
})();
